import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, Utensils, Calculator, MessageCircle, Map } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-kitchen-amber" data-id="element-159" />,
    title: "Guía Maestra 'Lunchera Vecinal'",
    desc: 'El paso a paso detallado para pasar de $0 a $150 al día.'
  }, {
    icon: <Utensils className="w-8 h-8 text-kitchen-terracotta" data-id="element-160" />,
    title: "El Menú 'Best-Seller'",
    desc: 'Los 5 platos que más dinero dejan y que los latinos en USA compran siempre.'
  }, {
    icon: <Calculator className="w-8 h-8 text-kitchen-green" data-id="element-161" />,
    title: 'Calculadora de Costos Real',
    desc: 'Para que sepas exactamente cuánto ganas por cada plato vendido.'
  }, {
    icon: <MessageCircle className="w-8 h-8 text-[#25D366]" data-id="element-162" />,
    title: 'Guiones de WhatsApp Mágicos',
    desc: 'Textos listos para copiar y pegar que cierran ventas solos.'
  }, {
    icon: <Map className="w-8 h-8 text-kitchen-brown" data-id="element-163" />,
    title: 'Manual de Logística a Pie',
    desc: 'Cómo organizar las entregas en tu edificio o complejo sin usar un auto.'
  }];
  return <section className="bg-kitchen-white py-12 md:py-20 px-5 md:px-12 lg:px-24" data-id="element-164">
      <div className="max-w-5xl mx-auto" data-id="element-165">
        <FadeIn data-id="element-166">
          <h2 className="font-lora text-2xl md:text-4xl font-bold text-kitchen-brown text-center mb-8 md:mb-16" data-id="element-167">
            Lo que te llevas hoy 🎁
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-168">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === 4 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-169">
              <div className="bg-kitchen-cream p-5 md:p-8 rounded-2xl border border-kitchen-amber/20 hover:border-kitchen-amber transition-colors h-full flex flex-col items-center text-center shadow-sm" data-id="element-170">
                <div className="bg-white p-3 md:p-4 rounded-full shadow-sm mb-4 md:mb-6" data-id="element-171">
                  {item.icon}
                </div>
                <h3 className="font-lora text-lg md:text-xl font-bold text-kitchen-brown mb-2 md:mb-3" data-id="element-172">
                  {item.title}
                </h3>
                <p className="font-nunito text-sm md:text-base text-kitchen-brown/80" data-id="element-173">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}